<template>
  <v-menu
    color="primary"
    ref="dateMenu"
    v-model="dateMenu"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    :max-width="`${$vuetify.breakpoint.xs ? 290 : 580}px`"
    min-width="290px"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        v-model="currentValue"
        v-bind="attrs"
        v-on="on"
        required
        readonly
        :rules="rules"
      >
        <template #label>
          {{ label || $t(`table.dateTime`) }}
          <span v-if="rules" class="red--text">
            <strong>*</strong>
          </span>
        </template>
      </v-text-field>
    </template>
    <v-time-picker
      color="primary"
      v-if="!readonly"
      v-model="time"
      ampm-in-title
      @input="_fnTimeInput"
    />
    <v-date-picker
      color="primary"
      v-if="!readonly"
      v-model="date"
      @input="_fnDateInput"
    />
  </v-menu>
</template>

<script>
export default {
  model: {
    prop: "value",
    event: "change",
  },
  props: {
    label: String,
    value: [String, Number],
    rules: Array,
    readonly: Boolean,
  },
  data() {
    return {
      dateMenu: false,
      date: "",
      time: "",
      currentValue: "",
    };
  },
  created() {
    if (this.value) {
      this.currentValue = this.$moment
        .unix(this.value)
        .format("HH:mm DD/MM/YYYY");
      this.date = this.$moment.unix(this.value).format("YYYY-MM-DD");
      this.time = this.$moment.unix(this.value).format("HH:mm");
    }
  },
  methods: {
    _fnFormatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    _fnDateInput(date) {
      this.date = date;
      this.currentValue =
        (this.time || "00:00") + " " + this._fnFormatDate(date);
      this.$emit(
        "change",
        this.$moment(`${this.currentValue}`, "HH:mm DD/MM/YYYY").unix()
      );
    },
    _fnTimeInput(time) {
      this.time = time;
      this.currentValue =
        this.time +
        " " +
        (this.date
          ? this._fnFormatDate(this.date)
          : this.$moment().format("DD/MM/YYYY"));
      this.$emit(
        "change",
        this.$moment(`${this.currentValue}`, "HH:mm DD/MM/YYYY").unix()
      );
    },
  },
};
</script>
